const computeSupportRepartitionProgramme = (support) => {
    const sumSupportProg = support.reduce((acc, { proportionVersementProgramme }) => (proportionVersementProgramme ? acc + proportionVersementProgramme : acc), 0);
    const roundedSumSupportProg = Math.round(sumSupportProg * 100);

    return roundedSumSupportProg;
};

export default computeSupportRepartitionProgramme;
